<template>
  <!-- update current plan modal -->
  <Transition
    enter-active-class="ease-out duration-300"
    enter-from-class=" opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isUpdateModal"
      @click.self="handleUpgradeModalClose"
      class="fixed z-50 inset-0 flex items-center justify-center bare-modalBg"
    >
      <Transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div v-if="isUpdateModal" class="p-5 rounded-md bg-white">
          <h1 class="text-base md:text-xl font-bold text-gray-800">
            Upgrade to Annual Subscription
          </h1>

          <h3 class="text-sm text-gray-600 italic mt-2 max-w-sm">
            By upgrading to an annual subscription, you can pay 1 time for the
            year and not have to think about it again. You also save 20% off the
            monthly price.
          </h3>

          <button
            @click="upgradePlan"
            class="mt-3 text-center flex items-center justify-center w-full px-3 py-2 rounded-md bg-brandGreen hover:to-brandGreenHover focus:outline-none text-white text-sm text-medium"
          >
            <Loader v-if="getAccountLoading" :whiteSmall="true" />
            <span v-if="!getAccountLoading">Upgrade plan</span>
          </button>
        </div>
      </Transition>
    </div>
  </Transition>
  <!-- end of update current plan modal -->
  <section
    v-if="getAccountInfo && getCurrentUser && !getAccountLoading"
    class="mt-14 md:mt-34 w-full min-h-screen bg-subtleGray"
  >
    <div class="relative pattern w-full">
      <div class="p-3 pb-0 md:p-6 md:pb-0 2xl:px-0 w-full max-w-1xl mx-auto">
        <div class="pt-6 flex items-start justify-between">
          <div class="mb-16 flex flex-col items-start justify-start">
            <h1 class="font-bold text-3xl text-white">
              My Account
            </h1>
          </div>
        </div>
        <div class="w-full relative pb-3">
          <div
            class="w-full absolute -mb-4 bottom-0 flex items-start justify-end gap-5"
          >
            <div class="flex items-start justify-center gap-5">
              <button
                @click="$router.go(-1)"
                class="px-5 py-2 border border-gray-300 rounded-md text-xs bg-white text-gray-800 font-medium focus:outline-none flex items-center justify-center"
              >
                <svg
                  class="w-4 h-4 mr-2 text-gray-700"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="block">Back</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="my-10 p-3 pb-0 md:p-6 md:pb-0 2xl:px-0 w-full max-w-1xl mx-auto"
    >
      <div
        class="w-full flex items-start justify-start flex-col lg:flex-row gap-10"
      >
        <!-- current plan -->
        <div
          v-if="getAccountInfo && getAccountInfo.userInfo[0].next_payment"
          class="w-full lg:max-w-md flex flex-col"
        >
          <div class="w-full bg-white shadow rounded-md">
            <div class="flex items-start justify-between">
              <h1 class="p-5 text-lg md:text-xl font-bold text-gray-700">
                Current Plan
              </h1>

              <span
                class="px-3 py-2 rounded-md rounded-tl-none shadow bg-brandPurple"
              >
                <h1 class="text-sm md:text-base  font-medium text-white">
                  {{
                    getAccountInfo.userInfo[0].plan_id === 649794
                      ? "Yearly"
                      : "Monthly"
                  }}
                </h1>
              </span>
            </div>

            <div
              v-if="getAccountInfo && getAccountInfo.userInfo[0].next_payment"
              class="p-5 pt-2 w-full"
            >
              <h2 class="text-sm text-gray-600">Subscription renewal date</h2>
              <div class="flex items-start justify-between">
                <h2 class="mt-1 text-sm text-gray-800 ">
                  {{
                    formatDate(
                      getAccountInfo &&
                        getAccountInfo.userInfo[0].next_payment &&
                        getAccountInfo.userInfo[0].next_payment.date
                    )
                  }}
                </h2>
                <span
                  v-if="
                    calculateRemainingDate(
                      getAccountInfo.userInfo[0].next_payment.date
                    ) <= 7
                  "
                  class="bg-gray-200 text-xs text-gray-800 p-1 rounded"
                  >{{
                    calculateRemainingDate(
                      getAccountInfo.userInfo[0].next_payment.date
                    )
                  }}
                  days remaining</span
                >
              </div>

              <h2 class="mt-3 text-sm text-gray-600">
                What you will be charged
              </h2>
              <h2 class="mt-1 text-sm text-gray-800">
                ${{ getAccountInfo.userInfo[0].next_payment.amount }} (including
                tax)
              </h2>
            </div>

            <div v-if="getAccountInfo.userInfo[0].plan_id === 10174" class="">
              <button
                @click="upgradeCurrentPlan"
                class="p-5 pt-0 text-sm text-gray-700 hover:underline hover:text-gray-800 font-medium focus:outline-none"
              >
                Upgrade to Annual Subscription
              </button>
            </div>
          </div>

          <button
            @click="cancelSubscription"
            class="mt-3 w-full block text-left text-xs text-gray-500 hover:underline focus:outline-none"
          >
            Cancel subscription
          </button>
        </div>
        <!-- end of current plan -->

        <!-- summary -->
        <div class="w-full bg-white shadow rounded-md">
          <div
            v-if="getAccountInfo && !getAccountInfo.userInfo[0].next_payment"
            class="flex items-start justify-between"
          >
            <h1 class="p-5 text-base font-medium text-gray-500">
              Your subscription ends on

              <span class="text-gray-800 font-bold ml-1 text-sm">{{
                getCurrentUser && getCurrentUser.cancelationEffectiveDate
              }}</span>
            </h1>
            <span
              class="px-3 py-2 rounded-md rounded-tl-none shadow bg-red-400"
            >
              <h1 class="text-sm md:text-base  font-medium text-white">
                Canceled
              </h1>
            </span>
          </div>
          <div class="flex items-start justify-between">
            <h1 class="p-5 text-lg md:text-xl font-bold text-gray-700">
              Payment Information
            </h1>
          </div>

          <div class="p-5 w-full">
            <div class="flex items-start justify-between">
              <h2 class="text-sm text-gray-600">Payment method</h2>

              <div class="flex items-end justify-start flex-col">
                <div class="flex items-start justify-start gap-5">
                  <!-- logo -->
                  <div
                    v-if="
                      getAccountInfo.userInfo[0].payment_information
                        .payment_method === 'card' &&
                        getAccountInfo.userInfo[0].payment_information
                          .card_type === 'visa'
                    "
                    class="p-1 rounded-md bg-blue-100"
                  >
                    <svg
                      class="text-blue-800 w-12 h-12"
                      aria-hidden="true"
                      focusable="false"
                      width="1em"
                      height="1em"
                      style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 32 32"
                    >
                      <path
                        d="M23.26 11.495a6.734 6.734 0 0 0-2.323-.401c-2.557 0-4.364 1.292-4.375 3.141c-.021 1.359 1.281 2.125 2.265 2.583c1.011.469 1.349.761 1.344 1.177c-.005.641-.808.927-1.547.927c-1.027 0-1.584-.14-2.443-.5l-.319-.151l-.364 2.136c.625.255 1.745.479 2.901.5c2.724 0 4.5-1.281 4.52-3.256c.021-1.083-.676-1.905-2.161-2.583c-.896-.437-1.457-.735-1.457-1.183c0-.396.479-.812 1.479-.812a4.763 4.763 0 0 1 1.937.359l.245.109l.359-2.057zm6.647-.224h-2c-.625 0-1.089.167-1.365.787l-3.844 8.713h2.719l.548-1.427l3.317.005c.083.333.317 1.421.317 1.421H32zm-17.027-.078h2.589l-1.62 9.504H11.26l1.62-9.509zm-6.583 5.234l.265 1.323l2.536-6.479h2.745l-4.084 9.484H5.026l-2.24-8.031a.507.507 0 0 0-.245-.317A10.935 10.935 0 0 0 0 11.464l.031-.199h4.177c.563.021 1.021.199 1.177.803l.912 4.364zm20.406.974l1.037-2.661c-.016.025.213-.547.343-.907l.177.817l.6 2.745h-2.157z"
                        fill="currentColor"
                      />
                      <rect
                        x="0"
                        y="0"
                        width="32"
                        height="32"
                        fill="rgba(0, 0, 0, 0)"
                      />
                    </svg>
                  </div>
                  <div
                    v-if="
                      getAccountInfo.userInfo[0].payment_information
                        .payment_method === 'card' &&
                        getAccountInfo.userInfo[0].payment_information
                          .card_type === 'master'
                    "
                    class="p-1 rounded-md bg-red-100"
                  >
                    <svg
                      class="w-12 h-12"
                      aria-hidden="true"
                      focusable="false"
                      style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 24 24"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <circle cx="7" cy="12" r="7" fill="#EA001B" />
                        <circle
                          cx="17"
                          cy="12"
                          r="7"
                          fill="#FFA200"
                          fill-opacity=".8"
                        />
                      </g>
                      <rect
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                        fill="rgba(0, 0, 0, 0)"
                      />
                    </svg>
                  </div>
                  <div
                    v-if="
                      getAccountInfo.userInfo[0].payment_information
                        .payment_method === 'paypal'
                    "
                    class="p-1 rounded-md bg-blue-100"
                  >
                    <svg
                      class="w-12 h-12"
                      aria-hidden="true"
                      focusable="false"
                      width="0.85em"
                      height="1em"
                      style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 256 302"
                    >
                      <path
                        d="M217.168 23.507C203.234 7.625 178.046.816 145.823.816h-93.52A13.393 13.393 0 0 0 39.076 12.11L.136 259.077c-.774 4.87 2.997 9.28 7.933 9.28h57.736l14.5-91.971l-.45 2.88c1.033-6.501 6.593-11.296 13.177-11.296h27.436c53.898 0 96.101-21.892 108.429-85.221c.366-1.873.683-3.696.957-5.477c-1.556-.824-1.556-.824 0 0c3.671-23.407-.025-39.34-12.686-53.765"
                        fill="#27346A"
                      />
                      <path
                        d="M102.397 68.84a11.737 11.737 0 0 1 5.053-1.14h73.318c8.682 0 16.78.565 24.18 1.756a101.6 101.6 0 0 1 6.177 1.182a89.928 89.928 0 0 1 8.59 2.347c3.638 1.215 7.026 2.63 10.14 4.287c3.67-23.416-.026-39.34-12.687-53.765C203.226 7.625 178.046.816 145.823.816H52.295C45.71.816 40.108 5.61 39.076 12.11L.136 259.068c-.774 4.878 2.997 9.282 7.925 9.282h57.744L95.888 77.58a11.717 11.717 0 0 1 6.509-8.74z"
                        fill="#27346A"
                      />
                      <path
                        d="M228.897 82.749c-12.328 63.32-54.53 85.221-108.429 85.221H93.024c-6.584 0-12.145 4.795-13.168 11.296L61.817 293.621c-.674 4.262 2.622 8.124 6.934 8.124h48.67a11.71 11.71 0 0 0 11.563-9.88l.474-2.48l9.173-58.136l.591-3.213a11.71 11.71 0 0 1 11.562-9.88h7.284c47.147 0 84.064-19.154 94.852-74.55c4.503-23.15 2.173-42.478-9.739-56.054c-3.613-4.112-8.1-7.508-13.327-10.28c-.283 1.79-.59 3.604-.957 5.477z"
                        fill="#2790C3"
                      />
                      <path
                        d="M216.952 72.128a89.928 89.928 0 0 0-5.818-1.49a109.904 109.904 0 0 0-6.177-1.174c-7.408-1.199-15.5-1.765-24.19-1.765h-73.309a11.57 11.57 0 0 0-5.053 1.149a11.683 11.683 0 0 0-6.51 8.74l-15.582 98.798l-.45 2.88c1.025-6.501 6.585-11.296 13.17-11.296h27.444c53.898 0 96.1-21.892 108.428-85.221c.367-1.873.675-3.688.958-5.477c-3.122-1.648-6.501-3.072-10.14-4.279a83.26 83.26 0 0 0-2.77-.865"
                        fill="#1F264F"
                      />
                      <rect
                        x="0"
                        y="0"
                        width="256"
                        height="302"
                        fill="rgba(0, 0, 0, 0)"
                      />
                    </svg>
                  </div>
                  <!-- end of logo -->

                  <div
                    v-if="
                      getAccountInfo.userInfo[0].payment_information &&
                        getAccountInfo.userInfo[0].payment_information
                          .payment_method === 'card'
                    "
                    class="flex flex-col justify-start items-end"
                  >
                    <h1 class="text-sm text-gray-800 font-medium">
                      **** **** ****
                      {{
                        getAccountInfo.userInfo[0].payment_information
                          .last_four_digits
                      }}
                    </h1>
                    <h3 class="mt-2 text-xs text-gray-600">
                      <span class="text-xs font-medium text-gray-800"
                        >Expiry date</span
                      >
                      {{
                        getAccountInfo.userInfo[0].payment_information
                          .expiry_date
                      }}
                    </h3>
                  </div>
                </div>
                <button
                  v-if="
                    getAccountInfo && getAccountInfo.userInfo[0].next_payment
                  "
                  @click="updatePayment"
                  class="mt-5 text-sm font-medium text-brandPurple hover:underline focus:outline-none"
                >
                  update payment method
                </button>
              </div>
            </div>

            <div
              class="mt-10 py-5 w-full max-h-72 overflow-y-auto flex flex-col border-t border-gray-300 gap-5"
            >
              <div
                v-for="payment in getAccountInfo.payments.filter(
                  (p) => p.is_paid === 1
                )"
                :key="payment.id"
                class="flex items-center justify-between"
              >
                <div class="flex items-center justify-center gap-3">
                  <h2 class="text-sm text-gray-600">
                    {{ payment.payout_date }}
                  </h2>
                  <a
                    :href="payment.receipt_url"
                    target="_blank"
                    download
                    class="text-sm text-gray-600 hover:text-gray-800 hover:underline"
                    >View reciept</a
                  >
                </div>
                <h2 class="text-sm text-gray-800">${{ payment.amount }}</h2>
              </div>
            </div>
          </div>
        </div>
        <!-- end of summary -->
      </div>
    </div>
  </section>

  <section
    v-if="!getAccountLoading && !getAccountInfo"
    class="bg-subtleGray min-h-screen flex items-center justify-center w-full"
  >
    <h1 class="text-sm text-gray-600 text-center">
      You dont have any past transactions
    </h1>
  </section>

  <section
    v-if="getAccountLoading"
    class="bg-subtleGray min-h-screen flex items-center justify-center w-full"
  >
    <Loader :brand="true" />
  </section>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import Loader from "../components/utils/Loader.vue";
export default {
  name: "account",
  components: { Loader },
  mounted() {
    if (this.$route.params.upgrade !== "upgrade") {
      this.fetchAccountDetails(this.$router);
    }
    if (this.$route.params.upgrade === "upgrade") {
      if (
        this.getCurrentUser &&
        this.getCurrentUser.subscription === "monthly"
      ) {
        this.isUpdateModal = true;
      } else {
        window.location = "/account";
      }
    }
  },
  computed: {
    ...mapGetters(["getAccountInfo"]),
    ...mapGetters(["getCurrentUser"]),
    ...mapGetters(["getAccountLoading"]),
  },
  methods: {
    ...mapActions(["fetchAccountDetails"]),
    ...mapActions(["upgradePlan"]),

    handleRedirect() {
      window.location = "/account";
    },

    handleUpgradeModalClose() {
      this.isUpdateModal = false;
      window.location = "/account";
    },

    formatDate(date) {
      return moment(date).format("MMMM DD YYYY");
    },
    calculateRemainingDate(dt) {
      var eventdate = moment(dt);
      var todaysdate = moment().format("YYYY-MM-DD");
      return eventdate.diff(todaysdate, "days");
    },
    updatePayment() {
      Paddle.Checkout.open({
        override: this.getCurrentUser.updateUrl,
        successCallback: this.handleRedirect,
      });
    },
    cancelSubscription() {
      Paddle.Checkout.open({
        override: this.getCurrentUser.cancelUrl,
        successCallback: this.handleRedirect,
      });
    },
    upgradeCurrentPlan() {
      this.isUpdateModal = true;
    },
  },
  data() {
    return {
      isUpdateModal: false,
    };
  },
  watch: {
    getAccountInfo: function(nv) {
      this.isUpdateModal = false;
    },
    $route: function(nv, ov) {
      if (nv.params.upgrade === "upgrade") {
        if (
          this.getCurrentUser &&
          this.getCurrentUser.subscription === "monthly"
        ) {
          this.isUpdateModal = true;
        } else {
          this.$router.push("/account");
        }
      }
    },
  },
};
</script>
<style scoped>
.pattern {
  background-color: #181818;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(0,842,429)'%3E%3Cstop offset='0' stop-color='%23181818'/%3E%3Cstop offset='1' stop-color='%23404040'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='436' height='363.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
